import React, { useState, useEffect } from "react";
import { Card, Typography, List, Button, Image, Row, Col } from "antd";
import { Popup } from "../../atoms/Popup";
import PdfViewer from "../../molecules/PDFViewer/pdfView";
import { getPresignedImage } from "../../../utils/media";
import { EditOutlined } from "@ant-design/icons";

const { Title } = Typography;

const ListPanel = (props) => {
  const [visible, setVisible] = useState(false);
  const [viewOrDownloadUrl, setViewOrDownloadUrl] = useState("");
  const [showPdf, setShowPdf] = useState(false);
  const { data, title, listHeight, clickPanel, leaseStatus,triggerValue } = props;

  const onClosePopUp = () => {
    setVisible(false);
  };

  const onOpenPopUpHandler = (object_key) => {
    if (object_key?.split(".")[1] === "pdf") {
      setShowPdf(!showPdf);
    } else {
      setVisible(true);
    }
  };

  const getUrl = async (data) => {

    let payload = typeof data !== 'string' ? data : [data]

    const url = await getPresignedImage(payload);
    setViewOrDownloadUrl(url[0]);
  };

  const popupContent = {
    closable: true,
    visibility: visible,
    content: (
      <Image
        preview={false}
        width="100%"
        style={{ padding: "20px" }}
        src={viewOrDownloadUrl}
      />
    ),
    width: 650,
    onCancel: onClosePopUp,
  };

    

  return (
    <>
      <PdfViewer
        pdf={viewOrDownloadUrl}
        onCancel={() => setShowPdf(false)}
        visible={showPdf}
      />
      <Row align="middle" gutter={16} style={{ marginBottom: "0.5rem" }}>
        <Col flex="auto">
          <Title level={5}>{title}</Title>
        </Col>
        <Col flex="none">
       {  <EditOutlined style={{cursor: 'pointer', color: '#3B3B3B'}} onClick={() => clickPanel(title,triggerValue)}/>}
        </Col>
      </Row>
      
      <Card
        bordered={false}
        className="ag-nospace-body panel-card"
        style={{ height: listHeight }}
      >
        <List
          dataSource={data}
          bordered
          renderItem={(item, index) => {
            let _item: any = item;
            _item.name && getUrl(_item.name);
            return (
              <List.Item key={index}>
                <List.Item.Meta
                  title={_item?.key}
                  description={
                    _item.name ? (
                      <Button
                        className="p-0"
                        type="link"
                        onClick={() => onOpenPopUpHandler(_item.name)}
                      >
                        {_item?.value}
                      </Button>
                    ) : (
                      _item?.value
                    )
                  }
                />
              </List.Item>
            );
          }}
        />
      </Card>
      <Popup {...popupContent} />
    </>
  );
};

export default ListPanel;
